// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"725":"d0f7de30","787":"e4ec6974","943":"a5150c54"}[chunkId] + ".chunk.js";
};